import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import List from './components/List'
import { PageVCardCreate } from './components/Create'
import Update from './components/Update'
import VCardDetail from './components/Detail'
import VCardPreview from './components/Preview'
const VCard: RouteObject = {
    path: 'account',
    children: [
        {
            path: 'vcards',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: (
                        <PageVCardCreate
                            pageType="create"
                            refetchData={() => {}}
                        />
                    ),
                },
                {
                    path: 'preview/:uuid',
                    element: <VCardPreview />,
                },
                {
                    path: ':id',
                    children: [
                        {
                            path: 'edit',
                            element: <Update />,
                        },
                    ],
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

const VCardPublic: RouteObject = {
    path: 'vcard',
    children: [
        {
            path: ':uuid',
            element: <VCardDetail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export { VCard, VCardPublic }
